import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { getLegacySensorState } from 'console/shared/hooks/device/legacy/sensors';
import { SensorContent } from './types';
import { useSelectDevice } from 'console/shared/hooks/device';
import { legacy_sensors_state } from 'console/shared/content/device/sensors/legacy/utils';
import { useLegacyDeviceState } from 'console/shared/hooks/device/legacy';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { currentServerUnixTime } from 'webui/utils/time';
export const LegacySensorProvider = memo(function LegacySensorProvider(props) {
    const { children, sensor_config } = props;
    const initial_state = useSelectDevice(legacy_sensors_state);
    const device_state = useLegacyDeviceState(initial_state);
    const current_server_time = useAppSelector((state) => currentServerUnixTime(state.server_time));
    const sensor_state = getLegacySensorState(sensor_config, device_state, current_server_time);
    const sensor = useMemo(() => ({
        ...sensor_config,
        ...sensor_state,
    }), [sensor_config, sensor_state]);
    return _jsx(SensorContent.Provider, { value: sensor, children: children });
});
